import client, { clientV2 } from "services/api/client";

export const getOneDaySaleAppraisal = (data: any) => {
    const formData = data;
    let url = `user/master/tradeIns`;

    let queryStr = `?limit=${formData.limit}&page=${formData.page}&sort=${formData.sort}`;
    //&column=${formData.dealTradeIn.id}&search=${formdata.search}&locationid=${formData.locationId}&tag=${formdata.tag}&statusId=${formdata.statusId}&oneDaySaleId=${formdata.oneDaySaleId}
 
    return client(url + queryStr, {   
        body: null,
        method: "GET",
    }).then(
        
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const getOneDaySaleAppraisalbyId = (id: any) => {
    let url = `user/master/tradeIns/${id}`;

    return client(url , {   
        body: null,
        method: "GET",
    }).then(
        
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};
//to remove
export const addOneDaySaleAppraisal = (data: any) => {
    return client(`user/master/oneDaySales`, {
        body: data,
        method: "POST"
    }).then(
        (data) => {

            return { result: data, error: null };
        },
        (error) => {

            return { result: null, error };
        }
    );
};

export const updateOneDaySaleAppraisal = (id:number,data: any) => {
    return client(`user/master/tradeIns/${id}`, {
        body: data,
        method: "PATCH"
    }).then(
        (data) => {

            return { result: data, error: null };
        },
        (error) => {

            return { result: null, error };
        }
    );
};

  export const getOneDaySaleDate = (data: any) => {
    const formData = data;
    let url = `user/master/oneDaySales`;

    let queryStr = `?limit=${formData.limit}&page=${formData.page}`;
    if (formData.allSaleDate !== undefined) {
        queryStr = queryStr + `&allSaleDate=${formData.allSaleDate}`;
    }
    if (formData.dateOrder !== undefined) {
        queryStr = queryStr + `&upComingSaleDate=${formData.dateOrder}`;
    }
    if (formData.sort) {
        queryStr = queryStr + `&sort=${formData.sort}`;
    }
    if (formData.column) {
        queryStr = queryStr + `&column=${formData.column}`;
    }
    return client(url + queryStr, {   
        body: null,
        method: "GET",
    }).then(
        
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const getOneDaySaleWorkbook = (data: any) => {
    const formData = data;
    let url = `user/master/tradeIns`;

    let queryStr = `?limit=${formData.limit}&page=${formData.page}&sort=${formData.sort}&column=${formData.column}`;
    if (formData.locationId) {
        queryStr = queryStr + `&locationId=${formData.locationId}`;
    }
    if (formData.search) {
        queryStr = queryStr + `&search=${formData.search}`;
    }
    if (formData.statusFilter) {
        queryStr = queryStr + `&statusId=${formData.statusFilter}`;
    }
    if (formData.tagFilter) {
        queryStr = queryStr + `&tag=${formData.tagFilter}`;
    }
    if (formData.saleDateFilter) {
        queryStr = queryStr + `&oneDaySaleId=${formData.saleDateFilter}`;
    }

    return client(url + queryStr, {   
        body: null,
        method: "GET",
    }).then(
        
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};



export const addOneDaySaleDate = (date: any) => {
    return client(`user/master/oneDaySales`, {
        body: date,
        method: "POST"
    }).then(
        (data) => {

            return { result: data, error: null };
        },
        (error) => {

            return { result: null, error };
        }
    );
};

export const saveOneDaySaleDateItem = (id:number,formData: any) => {
    return client(`user/master/oneDaySales/${id}`, {
        body: formData,
        method: "PATCH"
    }).then(
        (data) => {

            return { result: data, error: null };
        },
        (error) => {

            return { result: null, error };
        }
    );
};

export const createDealTradeIn = (dealTradeIn:any) => {
    return client(
        `user/master/tradeIns`,
        { body: dealTradeIn, method: "POST" }
    ).then(
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const getOneDaySaleNotes =  async (dealTradeInId) => {
    const query = `user/master/tradeIns/${dealTradeInId}/notes`;
  return client(query, { body: null }).then(
    (data) => {
      return { data, error: null };
    },
    (error) => {
      return { data: null, error };
    }
  );
};

export const saveOneDaySaleNotes = async (details: any,dealTradeInId: any) => {
    const query = `user/master/tradeIns/${dealTradeInId}/notes`;
  return client(query, { body: details, method: 'POST' }).then(
    (data) => {
      return { data,dealTradeInId, error: null };
    },
    (error) => {
      return { data: null,dealTradeInId, error };
    }
  );
};

export const deleteOneDaySaleDateItem = (id:number) => {
    return client(`user/master/oneDaySales/${id}`, {
        body: null,
        method: "DELETE"
    }).then(
        (data) => {

            return { result: data, error: null };
        },
        (error) => {

            return { result: null, error };
        }
    );
};

export const getAppraisalVehicleVIN = async (vin: string) => {
    let body = {
        vin
    };
    let method = 'POST';
    let query = `user/master/tradeIns/nhtsa/search/vin`;

        
    return clientV2(query, { body, method }).then(
        (dataFilter) => {
            return { dataFilter, errorFilter: null };
        },
        (errorFilter) => {
            return { dataFilter: null, errorFilter };  
        }
    );
};

export const getAppraisalVehicleDetails = async (ymm: any,tradeInId?: number) => {
    
    let query;
    if (ymm && ymm.year) {
        query = `user/master/tradeIns/${tradeInId}/ymm`;
            
    } else {
        query = `user/master/tradeIns/${tradeInId}/vin`;
            
    }
    return client(query, { body: ymm, method: 'POST' }).then(
        (dataFilter) => {
            return { dataFilter, errorFilter: null };
        },
        (errorFilter) => {
            return { dataFilter: null, errorFilter };
        }
    );
};

export const saveOneDaySaleAppraisal = (appraisal: any, tradeInId = 0) => {
    if (tradeInId) {
        return client(
            `user/master/${tradeInId}/tradeIns`,
            { body: appraisal, method: "PATCH" }
        ).then(
            (data) => {
                return { data, error: null };
            },
            (error) => {
                return { data: null, error };
            }
        );
    }
    return client(
        `user/master/tradeIns`,
        { body: appraisal, method: "POST" }
    ).then(
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const getOneDayAppraisalTable = ({ tradeInId }: { tradeInId: number | string }) => {
    return client(
        `user/master/tradeIns/${tradeInId}/appraisals`,
        { body: null },
        false
    ).then(
        (data) => ({ data, error: null }),
        (error) => ({ data: null, error })
    );
};

export const addOneDayAppraisalTableItem = (tradeInId: number | string, formData: any) => {
    return client(`user/master/tradeIns/${tradeInId}/appraisals`, {
        body: formData,
        method: "POST"
    }).then(
        (data) => ({ result: data, error: null }),
        (error) => ({ result: null, error })
    );
};

export const createOneDayAppraisalDealTradeIn = (tradeIn: any) => {
    return client(`user/master/tradeIns`, {
        body: tradeIn,
        method: "POST"
    }).then(
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const searchOneDaySaleDealRecord = (id:any,deal: any) => {
    return client(
        `user/master/tradeIns/${id}/deal/search`,
        { body: deal, method: "POST" }
    ).then(
        
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const createOneDaySaleDealRecord = (id:any,deal: any) => {
    return client(
        `user/master/tradeIns/${id}/deal`,
        { body: deal, method: "POST" }
    ).then(
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const createAppraisalFormvalues = (tradeIn: any) => {
    return client(`user/master/tradeIns`, {
        body: tradeIn,
        method: "POST"
    }).then(
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const addOneDaySaleToDealTradeIn = (id:any,deal: any) => {
    return client(
        `user/master/tradeIns/${id}/deal/tradeIn`,
        { body: deal, method: "POST" }
    ).then(
        (data) => {
            return { data, error: null };
        },
        (error) => {
            return { data: null, error };
        }
    );
};

export const deleteOneDaySale = (id:number) => {
    return client(`user/master/tradeIns/${id}`, {
        body: null,
        method: "DELETE"
    }).then(
        (data) => {

            return { result: data, error: null };
        },
        (error) => {

            return { result: null, error };
        }
    );
};
